module.exports = __webpack_public_path__ + "img/MS-M-10.14296734.svg";